export const getISTTime = () => {
  const now = new Date();
  const istOffset = 5.5 * 60 * 60 * 1000; // Convert 5.5 hours to milliseconds
  const istTime = new Date(now.getTime() + istOffset);
  return istTime.toISOString().replace("Z", "+05:30"); // Keep the ISO format with IST offset
};

/** "April 2026" style label in Asia/Kolkata; updates when the IST calendar month changes. */
export const getISTCalendarMonthYear = () =>
  new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    month: "long",
    year: "numeric",
  }).format(new Date());

/** "Accepting Applications till 30th September!" — last day of current IST month, auto-rolls monthly. */
export const getISTAcceptingTillLabel = () => {
  const now = new Date();
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "numeric",
  }).formatToParts(now);
  const month = Number(parts.find((p) => p.type === "month").value) - 1;
  const year = Number(parts.find((p) => p.type === "year").value);
  const lastDay = new Date(year, month + 1, 0).getDate();
  const monthName = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    month: "long",
  }).format(now);
  const v = lastDay % 100;
  const suffix = (lastDay % 10 === 1 && v !== 11) ? "st"
    : (lastDay % 10 === 2 && v !== 12) ? "nd"
    : (lastDay % 10 === 3 && v !== 13) ? "rd" : "th";
  return `Accepting Applications till ${lastDay}${suffix} ${monthName}!`;
};

export const getFormattedTimestamp = () => {
  const now = new Date();
  return now.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });
};

/**
 * Replaces IST with EST in time string (no time conversion)
 * @param {string} istTimeString - Time string like "10 AM IST", "7 PM IST", "11 AM IST"
 * @returns {string} EST time string like "10 AM EST", "7 PM EST", "11 AM EST"
 */
export const convertISTToEST = (istTimeString) => {
  // Simply replace IST with EST
  return istTimeString.replace(/IST/gi, "EST");
};

export default getISTTime;
